import { useEffect, useState } from "react";
import { PawPrint } from "./Doodles";

const LINKS = [
  { label: "Mission", href: "#mission" },
  { label: "Story", href: "#story" },
  { label: "Team", href: "#team" },
  { label: "Donate", href: "#donate" },
];

const Navbar = ({ onNavigate }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 bg-[#FBF3E3]/95 backdrop-blur-sm transition-shadow duration-300 ${
        scrolled ? "border-b-2 border-[#16294B] shadow-[0_4px_0_0_rgba(10,25,47,0.08)]" : ""
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8" aria-label="Main navigation">
        <button
          data-testid="nav-logo-btn"
          onClick={() => onNavigate("#top")}
          className="flex items-center gap-2"
          aria-label="Project Archie home"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-[#16294B] bg-[#3B82F6] shadow-[3px_3px_0_0_#16294B]">
            <PawPrint className="h-5 w-5" color="#FBF3E3" />
          </span>
          <span className="font-display text-2xl tracking-wide text-[#16294B]">PROJECT ARCHIE</span>
        </button>

        <div className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => onNavigate(l.href)}
              className="text-sm font-semibold uppercase tracking-widest text-[#16294B] transition-colors hover:text-[#E63946]"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-join-btn"
            onClick={() => onNavigate("#join")}
            className="btn-press rounded-full border-2 border-[#16294B] bg-[#E63946] px-5 py-2 text-sm font-bold uppercase tracking-widest text-[#FBF3E3] shadow-[4px_4px_0_0_#16294B]"
          >
            Join a Build
          </button>
        </div>

        <button
          data-testid="nav-join-btn-mobile"
          onClick={() => onNavigate("#join")}
          className="btn-press rounded-full border-2 border-[#16294B] bg-[#E63946] px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[#FBF3E3] shadow-[3px_3px_0_0_#16294B] md:hidden"
        >
          Join
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
